/**
 * Copyright (c) Microsoft. All rights reserved.
 */
import * as Msal from 'msal';
import { LuisConstants } from 'src/core/utils/LuisConstants';
import { routeTable } from 'src/core/utils/routeTable';

const redirectUri: string = `${window.location.origin}${routeTable.qnaMaker.root()}`;

export const userAgentApplication = new Msal.UserAgentApplication({
    auth: { clientId: LuisConstants.QnaMaker.SharePointAuthWebAppClientId, redirectUri }
});
